import React from 'react';
import { PlusIcon } from '@heroicons/react/24/outline';

interface FilterButtonProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
  onRemove?: () => void;
  showRemove?: boolean;
}

export const FilterButton: React.FC<FilterButtonProps> = ({
  label,
  isActive,
  onClick,
  onRemove,
  showRemove = false
}) => {
  return (
    <div
      className={`box-border content-stretch flex gap-[4px] items-center justify-center overflow-clip px-[8px] py-[6px] relative rounded-[16px] shrink-0 transition-all cursor-pointer h-8 ${
        isActive 
          ? 'bg-white border border-[#e16349] hover:bg-gray-50' 
          : 'bg-gray-100 hover:bg-gray-200'
      }`}
      onClick={onClick}
    >
      {/* Иконка плюса или крестика - перемещается вправо при выборе */}
      {showRemove && onRemove ? (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="overflow-clip relative shrink-0 size-[20px] hover:bg-gray-100 rounded-full p-0.5 transition-colors order-2"
        >
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24">
            <path d="M15 5L5 15M5 5l10 10" stroke="#e16349" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      ) : (
        <div className="overflow-clip relative shrink-0 size-[20px] order-1">
          <PlusIcon className={`h-5 w-5 font-bold ${isActive ? 'text-[#e16349]' : 'text-[#0a0d14]'}`} />
        </div>
      )}

      {/* Текст лейбла */}
      <div className={`box-border content-stretch flex gap-[8px] items-center justify-center px-[4px] py-0 relative shrink-0 ${showRemove ? 'order-1' : 'order-2'}`}>
        <div className={`font-inter font-normal leading-[0] not-italic relative shrink-0 text-[14px] text-center text-nowrap tracking-[-0.084px] ${
          isActive ? 'text-[#e16349]' : 'text-[#0a0d14]'
        }`}>
          <p className="leading-[20px] whitespace-pre">{label}</p>
        </div>
      </div>
    </div>
  );
};

export default FilterButton;
